import { useStore } from 'stook'
import { TAB_ID_SET } from '../config/constants';
import {
  ReservationItemTypes,
  STORE_ITEMS_CAPACITY,
  DATE_RANGE_ITEM,
  DATE_RANGE_STORE_ITEM,
  TimeDataTypes,
} from '../interfaces/home';

interface IBasicFormData {
  reserveItemsStepData: StepOneInfoTypes;
  storeTimeStepData: StepTwoInfoTypes;
  contactInfoStepData: StepThreeInfoTypes;
}

interface StepOneInfoTypes {
  serviceItemState: ReservationItemTypes[] // 全部项目列表（带选中状态
}
interface StepTwoInfoTypes {
  reserveType: number; // tab1/tab2
  storeDataByStoreTab: null | STORE_ITEMS_CAPACITY,
  storeDataByDateTab: null | STORE_ITEMS_CAPACITY,
  reserveDateDataByStoreTab: DATE_RANGE_ITEM[] | null, // 按门店选择，预约日期列表
  datesStoreDataByDateTab: DATE_RANGE_STORE_ITEM[] | null, // 按日期选择，门店列表
  arriveStoreTimeData: null | TimeDataTypes, // 按门店到店时间
  arriveStoreTimeByDateTab: null | TimeDataTypes, // 按日期到店时间
  modifyOrderArriveTime: number,
  modifyOrderShopCode: string;
  // dataByStore: {
  //   currentStoreData: null | STORE_ITEMS_CAPACITY,
  // };
}

interface StepThreeInfoTypes {
  contactName: string;
  contactPhone: string;
  loadedServiceRight: boolean;
  hasPickupServiceRight: boolean;
  usePickupService: boolean;
  pickupRightUrl: string;
  pickupServiceTime: string;
  pickupServiceAddr: string;
  /**
   * 取送车时间较预约时间太远（大于14天）
   */
  pickupServiceTooFar: boolean | null;
}

const INIT_FORM_DATA = {
  reserveItemsStepData: {
    serviceItemState: [],
  },
  storeTimeStepData: {
    reserveType: TAB_ID_SET.DATE_TAB,
    storeDataByStoreTab: null,
    storeDataByDateTab: null,
    reserveDateDataByStoreTab: null,
    datesStoreDataByDateTab: null,
    arriveStoreTimeData: null,
    arriveStoreTimeByDateTab: null,
    modifyOrderArriveTime: 0,
    modifyOrderShopCode: '',
  },
  contactInfoStepData: {
    contactName: '',
    contactPhone: '',
    loadedServiceRight: false,
    hasPickupServiceRight: false,
    usePickupService: true,
    pickupRightUrl: '',
    pickupServiceTime: '',
    pickupServiceAddr: '',
    pickupServiceTooFar: false,
  }
}

export default function useBasicFormData() {
  const [basicFormData, setBasicFormInfo] = useStore<IBasicFormData>('basicFormData', INIT_FORM_DATA);

  // 设置步骤1数据选项
  const setReserveItemsData = data => {
    setBasicFormInfo((state) => {
      state.reserveItemsStepData.serviceItemState = data
    })
  }

  // 设置步骤2数据
  const setStoreTimeTabIndex = data => {
    setBasicFormInfo((state) => {
      state.storeTimeStepData.reserveType = data
    })
  }

  // 设置 store tab 的 store 内容 
  const setStoreContentOfStoreTab = data => {
    setBasicFormInfo((state) => {
      state.storeTimeStepData.storeDataByStoreTab = data
    })
  }
  // 设置修改订单的到店时间
  const setModifyOrderArriveStoreTime = data => {
    setBasicFormInfo((state) => {
      state.storeTimeStepData.modifyOrderArriveTime = data
    })
  }

  // 设置修改订单的门店编码
  const setModifyOrderShopCode = data => {
    setBasicFormInfo((state) => {
      state.storeTimeStepData.modifyOrderShopCode = data
    })
  }

  // 设置 store tab 的 时间选择内容 
  const setDatesContentOfStoreTab = data => {
    setBasicFormInfo((state) => {
      state.storeTimeStepData.reserveDateDataByStoreTab = data;
    })
  }
  
  // 设置 Date tab 的 时间选择内容
  const setDatesStoreContentOfDateTab = data => {
    // console.log('setStoreContentOfDateTab sssssssssss>>>>>>>>>', data)
    setBasicFormInfo((state) => {
      state.storeTimeStepData.datesStoreDataByDateTab = data;
    })
  }

  // 设置 date tab 选中的 store 内容 
  const setStoreContentOfDateTab = data => {
    setBasicFormInfo((state) => {
      state.storeTimeStepData.storeDataByDateTab = data
    })
  }

  // 设置门店维度到店时间
  const setArriveStoreTimeData = data => {
    setBasicFormInfo((state) => {
      state.storeTimeStepData.arriveStoreTimeData = data
    })
  }

  // 设置日期维度到店时间
  const setArriveStoreTimeByDateTab = data => {
    setBasicFormInfo((state) => {
      state.storeTimeStepData.arriveStoreTimeByDateTab = data
    })
  }

  // 设置联系信息内容
  const setContactInfoData = data => {
    setBasicFormInfo((state) => {
      state.contactInfoStepData = {
        ...state.contactInfoStepData,
        ...data
      }
    })
  }

  const resetBasicInfoData = () => {
    setBasicFormInfo(state => {
      state.reserveItemsStepData = INIT_FORM_DATA.reserveItemsStepData
      state.storeTimeStepData = INIT_FORM_DATA.storeTimeStepData
      state.contactInfoStepData = INIT_FORM_DATA.contactInfoStepData
    });
  }

  const resetStoreAndDateData = () => {
    setStoreContentOfStoreTab(null);
    setDatesContentOfStoreTab(null);
    setDatesStoreContentOfDateTab(null);
    setStoreContentOfDateTab(null);
    setArriveStoreTimeData(null);
    setArriveStoreTimeByDateTab(null);
  }

  return {
    basicFormData,
    setReserveItemsData,
    setStoreTimeTabIndex,
    setStoreContentOfStoreTab,
    setModifyOrderArriveStoreTime,
    setModifyOrderShopCode,
    setStoreContentOfDateTab,
    setDatesContentOfStoreTab,
    setArriveStoreTimeData,
    setArriveStoreTimeByDateTab,
    setDatesStoreContentOfDateTab,
    setContactInfoData,
    resetBasicInfoData,
    resetStoreAndDateData
  }
}
